import { Deserializable } from '../../../models/protocols/deserializable';

export class PaylineCurrencyType implements Deserializable {
  public id!: number; // TODO: Make this an enum
  public code!: string;
  public name!: string;

  public onDeserialize(): void {}
}
